define("CallForPricing", [
    'ProductViews.Price.View',
    'Profile.Model'
], function(
    ProductViewsPriceView,
    ProfileModel
    ) {
        "use strict";

        return {
            checkCall4Pricing: function checkCall4Pricing(item) {
                var self = this;
                var showCall4Pricing = false;
                var call4pricingText = "";
                var call4pricingTextB2B;
                var call4pricingTextB2C;
                var call4pricingSegmentation;
                // console.log('this', this);

                var pdp = this.container.getComponent("PDP");
                if(item && item.get){
                    // console.log('item', item);
                    call4pricingSegmentation = item.get('custitem_ano_call4pricing_segmentation');
                    call4pricingTextB2B = item.get('custitem_ano_call4pricing_text_b2b');
                    call4pricingTextB2C = item.get('custitem_ano_call4pricing_text_b2c');
                    // console.log('call4pricingTextB2B',call4pricingTextB2B);
                    // console.log('call4pricingTextB2C',call4pricingTextB2C);
                    // console.log('call4pricingSegmentation',call4pricingSegmentation);
                } else if(item){
                    call4pricingSegmentation = item.custitem_ano_call4pricing_segmentation;
                    call4pricingTextB2B = item.custitem_ano_call4pricing_text_b2b;
                    call4pricingTextB2C = item.custitem_ano_call4pricing_text_b2c;
                } else {
                  	call4pricingSegmentation = pdp.getItemInfo() ? pdp.getItemInfo().item.custitem_ano_call4pricing_segmentation : false;
                    call4pricingTextB2B = pdp.getItemInfo() ? pdp.getItemInfo().item.custitem_ano_call4pricing_text_b2b : '';
                    call4pricingTextB2C = pdp.getItemInfo() ? pdp.getItemInfo().item.custitem_ano_call4pricing_text_b2c : '';
                }

                //If call for pricing for both, display the call for pricing text based on isB2B
                if (call4pricingSegmentation === "Both") {
                    call4pricingText = self.isB2B ? call4pricingTextB2B : call4pricingTextB2C
                    showCall4Pricing = true;
                } else if (self.isB2B && call4pricingSegmentation === "B2B") {
                    call4pricingText = call4pricingTextB2B;
                    showCall4Pricing = true;
                } else if (!self.isB2B && call4pricingSegmentation === "B2C") {
                    call4pricingText = call4pricingTextB2C;
                    showCall4Pricing = true;
                }
                return {
                    showCall4Pricing: showCall4Pricing,
                    call4pricingText: call4pricingText
                };
            },

            loadModule: function loadModule(container) {
                // console.log('call for container', container);
                var self = this;
                this.container = container;
                var Layout = this.container.getComponent("Layout");
                var PDP = this.container.getComponent("PDP");
                // var model = ProfileModel.getInstance();
				// console.log('call for model',model);
                var userProfileComponent = container.getComponent("UserProfile");
                _.defer(function() {
                    userProfileComponent.getUserProfile().then(function(profile) {
                        self.isB2B = profile.isloggedin ? _.findWhere(profile.customfields, { id: "custentity_ano_is_b2b" }).value : false;
                    });

                });



                PDP.on('afterShowContent', function (){
                    // Product.Price
                    // Quantity.Pricing
                    // Product.Options
                    // Quantity
                    // MainActionView
                    // AddToProductList
                    // ProductDetails.AddToQuote
                    var call4pricing = self.checkCall4Pricing();
                    if(call4pricing.showCall4Pricing){
                        var pricingText = (call4pricing.call4pricingText || '')
                            .replace(/&lt;/g, '<')
                            .replace(/&gt;/g, '>')
                            .replace(/&amp;/g, '&');

                        jQuery('[data-view="Product.Price"]').html("<p>" + pricingText + "</p>");
                        jQuery('[data-view="Quantity.Pricing"]').empty();
                        jQuery('[data-view="Product.Options"]').empty();
                        jQuery('[data-view="Quantity"]').empty();
                        jQuery('[data-view="MainActionView"]').empty();
                        jQuery('[data-view="AddToProductList"]').empty();
                        jQuery('[data-view="ProductDetails.AddToQuote"]').empty();
                    }
                });

                _.extend(ProductViewsPriceView.prototype, {
                    initialize: _.wrap(ProductViewsPriceView.prototype.initialize, function wrapInitialize(fn, options){
                        var view = this;
                        fn.apply(this, _.toArray(arguments).slice(1));
                        this.on('afterViewRender', function (){
                            if(view.placeholderData.view === 'ProductViewsPrice.Price'){
                                var item = view.model.get('item');
                            } else if(view.placeholderData.view === 'Item.Price') {
                                var item = view.model;
                            }
                            var call4pricing = self.checkCall4Pricing(item);
                            if(call4pricing.showCall4Pricing){
                                var pricingText = (call4pricing.call4pricingText || '')
                                    .replace(/&lt;/g, '<')
                                    .replace(/&gt;/g, '>')
                                    .replace(/&amp;/g, '&');
                                jQuery('.product-views-price', view.$el).html("<p>" + pricingText + "</p>");;
                            }
                        });
                    })
                });

            }
        };
    });
                 
